// extracted by mini-css-extract-plugin
export default {"mainUniformPic":"ChooseUniformStack_mainUniformPic__GkNAV","totalSum":"ChooseUniformStack_totalSum__83Gtl"};